import { IconSvg, IconSvgProps } from "./icon"

export default function Cross(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M19 5 5 19M5 5l14 14" />
    </IconSvg>
  )
}
